<script setup>
import { provide, ref } from 'vue';

/**
 * @typedef {Object} Disclosure
 * @property {() => void} close - Closes the disclosure.
 * @property {boolean} alwaysOpen - Whether the disclosure must stay open.
 */

/** @type {Set<Disclosure>} */
const disclosures = new Set();

const currentDisclosure = ref(null);

/**
 * Registers a disclosure so it can be closed when another one is opened.
 *
 * @param {Disclosure} disclosure
 * @returns {() => void} The function unregistering the disclosure.
 */
function registerDisclosure(disclosure) {
    disclosures.add(disclosure);

    return () => disclosures.delete(disclosure);
}

/**
 * Keeps only the given disclosure open within the group.
 *
 * @param {Disclosure} disclosure
 */
function setCurrentDisclosure(disclosure) {
    currentDisclosure.value = disclosure;

    disclosures.forEach((registeredDisclosure) => {
        if (
            registeredDisclosure !== disclosure &&
            !registeredDisclosure.alwaysOpen
        ) {
            registeredDisclosure.close();
        }
    });
}

provide('menuGroup', { registerDisclosure, setCurrentDisclosure });
</script>

<template>
    <div class="flex flex-col gap-2">
        <slot
            :currentDisclosure="currentDisclosure"
            :setCurrentDisclosure="setCurrentDisclosure"
        />
    </div>
</template>
